<template>
  <v-card outlined style="margin-bottom: 24px">
    <UpdateLeadContactForm ref="update-dialog" @refresh="() => $emit('refresh')" />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Thông tin liên lạc</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="() => $refs['update-dialog'].open()"
        style="height: 18px"
        v-if="authorized"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhật
      </v-btn>
    </div>

    <v-row class="px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text my-0">Số điện thoại</p>
        <p class="my-0">{{ profile.phone }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text my-0">Email</p>
        <p class="my-0">{{ $_get(profile, 'email', 'Chưa có thông tin') }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text my-0">Họ tên</p>
        <p class="my-0">{{ $_get(profile, 'buyerName', 'Chưa có thông tin') }}</p>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import UpdateLeadContactForm from '@/components/basic/form/UpdateLeadContactForm.vue'
import { mapGetters } from 'vuex'
export default {
  props: { authorized: Boolean },
  components: { UpdateLeadContactForm },
  computed: { ...mapGetters({ profile: 'lead/item' }) },
}
</script>
